import { Pipe, PipeTransform } from '@angular/core';
import 'intl';
import 'intl/locale-data/jsonp/en.js';


@Pipe({
    name: 'ccFormat'
})
export class CCPipe implements PipeTransform {
   
    getCCFormat(value: number,store:any, displayCC: boolean = true): string {
        if (store) {
            const ccformat: string = store.ccNumberFormat;
            const commissionSymbol = store.ccSymbol;
            const decimalLength: number = store.ccNumberDecimals;
            const chunkDelimiter: string = store.thousandSeperator;
            const decimalDelimiter: string = store.decimalSeparator;
            const chunkLength = 3;
            if (value !== undefined && value !== null) {
                const result = '\\d(?=(\\d{' + chunkLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
                // tslint:disable-next-line:no-bitwise
                const num = value.toFixed(Math.max(0, ~~decimalLength));
                const totalCommission = (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).
                replace(new RegExp(result, 'g'), '$&' + chunkDelimiter);
                // return commisionValue+" "+units;
                let commissionableValue;
                switch (ccformat) {
                    case 'CL':
                        commissionableValue = displayCC ? commissionSymbol + ' ' + totalCommission : totalCommission;
                        break;
                    case 'CR':
                        commissionableValue = displayCC ? totalCommission + ' ' + commissionSymbol : totalCommission;
                        break;
                    default:
                        commissionableValue = displayCC ? totalCommission + ' ' + commissionSymbol : totalCommission;
                        break;
                }
                return commissionableValue;
            } 
        }
    }
    transform(value: number,store:any, displayCC: boolean = true): string {
        return this.getCCFormat(value,store, displayCC);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/cc-value-format.pipe.ts